import { useState } from 'react'
import React from 'react'
import { Button } from 'antd-mobile'
import ReactMarkdown from 'react-markdown'
import '../styles/EditRecommendationModal.css'
import SleepAnalysisModal from '../WorkoutDetails/SleepAnalysisModal'

function SleepCard({ recommendationsByDay = {}, sleepRecommendations = {} }) {
  const {
    action_plan = 'No action plan available.',
    areas_for_attention = 'No areas for attention available.',
    sleep_analysis = 'No sleep analysis available.',
    whats_working_well = 'No information on what\'s working well available.'
  } = sleepRecommendations || {}
  
  const [showSleepAnalysis, setShowSleepAnalysis] = useState(false)

  return (
    <div>
      <ul style={{ paddingLeft: '14px' }}>
        <li className="observations-text">
          <ReactMarkdown>{whats_working_well}</ReactMarkdown>
        </li>
        <li className="observations-text">
          <ReactMarkdown>{areas_for_attention}</ReactMarkdown>
        </li>
        <li className="observations-text">
          <ReactMarkdown>{action_plan}</ReactMarkdown>
        </li>
      </ul>
      {sleep_analysis && sleep_analysis !== 'No sleep analysis available.' && (
        <>
          <Button
            className="read-more-button"
            onClick={() => setShowSleepAnalysis(true)}
          >
            Read More...
          </Button>
          <SleepAnalysisModal
            visible={showSleepAnalysis}
            onClose={() => setShowSleepAnalysis(false)}
            sleep_analysis={sleep_analysis}
          />
        </>
      )}
    </div>
  )
}

export default SleepCard
